let baseDomain = {}
baseDomain.cookieDomain = 'youwovision.com'
baseDomain.appId = '83'
baseDomain.global = false
/*
  production:线上部署环境   打包命令:npm run build
  test:测试部署环境         打包命令：npm run test
  development：本地开发环境   本地运行:npm run dev
*/
if (process.env.NODE_ENV === 'production') {
  //用户中心和和登录域名


} else if (process.env.NODE_ENV === 'development') {
  //用户中心和和登录域名


} else if (process.env.NODE_ENV === 'test') {
  //用户中心和和登录域名

}
export default baseDomain
